import { Title } from "../common/Title"
import appStyles from '../../App.module.css'

export const Reports = () => {

    return (
        <section className={appStyles.card}>
            <div>
                <Title icon='fa fa-chart-line fa-fw'>Reports</Title>

                <p>Planned functionality. Not subject to SoftUni project defense.</p>
                


            </div>
        </section>
    )
}